/**
 * @file:
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-11-29 16:45:00
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-11-29 16:50:21
 * @FilePath: /console-znzs/new_src/directives/loadmore.js
 */

import {useResizeObserver} from './useResizeObserver';
/**
 * 表格触底加载
 */
const loadMore = {
    bind(el: any, binding: any) {
        const wrap = el.querySelector('.el-table__body-wrapper');
        const fn = () => {
            const scrollDistance = wrap.scrollHeight - wrap.clientHeight - wrap.scrollTop;
            if (scrollDistance < 1) {
                binding.value();
            }
        };

        useResizeObserver(wrap, () => {
            if (wrap.scrollHeight - wrap.clientHeight >= 1) {
                console.log('可滚动表格');
                wrap.addEventListener('scroll', fn);
            }
            else {
                wrap.removeEventListener('scroll', fn);
            }
        });
    },
};

export default (Vue: any) => {
    Vue.directive('loadmore', loadMore);
};